module.exports = __webpack_public_path__ + "static/schooling-c1ce9f6f90361e8cff8227aa467c94af.png";